import { RESET_STATE } from 'store/global/actions';

import {
  GET_DOCUMENT_CATEGORIES,
  MOVE_DOCUMENT_TYPE_TO_ANOTHER_CATEGORY,
  REORDER_DOCUMENT_TYPE_IN_CATEGORY,
} from '../actions';

const initialState = null;

const documentCategories = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_DOCUMENT_CATEGORIES:
    case REORDER_DOCUMENT_TYPE_IN_CATEGORY:

    case MOVE_DOCUMENT_TYPE_TO_ANOTHER_CATEGORY: {
      return payload;
    }

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default documentCategories;
